import { gql, useQuery } from '@apollo/client';

export const PO_SALE_ORDER_LIST_QUERY = gql`
  query PoSaleOrderList(
    $page: Int!
    $pageSize: Int!
    $startDate: Date
    $endDate: Date
    $ngayDatHangStartDate: Date
    $ngayDatHangEndDate: Date
    $orderStatus: PoSaleOrderStatus
    $distributorCds: [String!]
    $customerCd: String
    $orderType: OrderType
    $sellType: SellType
    $poSaleOrderCd: String
    $salesmanCd: String
    $referencePo: String
    $orderSource: OrderSource
    $filter: String
    $heThongMT: [String!]
  ) {
    poSaleOrder {
      poSaleOrders(
        page: $page
        pageSize: $pageSize
        orderStatus: $orderStatus
        startDate: $startDate
        endDate: $endDate
        ngayDatHangStartDate: $ngayDatHangStartDate
        ngayDatHangEndDate: $ngayDatHangEndDate
        salesmanCd: $salesmanCd
        distributorCds: $distributorCds
        customerCd: $customerCd
        orderType: $orderType
        sellType: $sellType
        poSaleOrderCd: $poSaleOrderCd
        referencePo: $referencePo
        orderSource: $orderSource
        filter: $filter
        heThongMT: $heThongMT
      ) {
        total
        data {
          id
          cd
          createdAt
          modifiedAt
          referencePo
          orderDate
          orderType
          sellType
          total
          orderTotal
          orderTotalAfterTax
          vat
          orderStatus
          orderSource
          description
          externalReference
          deliveryAddress
          receiver
          nguoiDatHang
          ngayYeuCauGiaoHang
          ngayDatHang
          creator {
            id
            cd
            name
          }
          modifiedBy {
            id
            cd
            name
          }
          customer {
            id
            cd
            name
            address1
            ward {
              id
              name
              district {
                id
                name
                province {
                  id
                  name
                }
              }
            }
          }
          distributor {
            id
            cd
            name
          }
          salesman {
            cd
            name
          }
        }
      }
    }
  }
`;

export interface PoSaleOrderListQueryVariables {
  page: number;
  pageSize: number;
  startDate?: string;
  endDate?: string;
  ngayDatHangStartDate?: string;
  ngayDatHangEndDate?: string;
  orderStatus?: string;
  distributorCds?: string[];
  customerCd?: string;
  orderType?: string;
  sellType?: string;
  poSaleOrderCd?: string;
  salesmanCd?: string;
  referencePo?: string;
  orderSource?: string;
  filter?: string;
  heThongMT?: string[];
}

export const usePoSaleOrderListQuery = (options?: any) => {
  return useQuery(PO_SALE_ORDER_LIST_QUERY, options);
};

